import React, { useEffect, useState } from "react";

const API_BASE_URL = "";

const emptyFaq = {
  question: "",
  answer: "",
};

const Faqs = () => {
  const [pages, setPages] = useState([]);
  const [selectedPageKey, setSelectedPageKey] = useState("");
  const [data, setData] = useState({
    pageName: "",
    title: "",
    items: [],
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const getToken = () => localStorage.getItem("indiaboatsAdminToken");

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/faqs`);

        if (!response.ok) {
          throw new Error("Failed to load FAQ pages");
        }

        const result = await response.json();

        setPages(result);

        if (result.length > 0) {
          const firstPage = result[0];
          setSelectedPageKey(firstPage.pageKey);
          setData({
            pageName: firstPage.pageName || "",
            title: firstPage.title || "",
            items: firstPage.items || [],
          });
        }
      } catch (error) {
        console.error("FAQ pages fetch error:", error);
        alert("Failed to load FAQ pages");
      } finally {
        setLoading(false);
      }
    };

    fetchPages();
  }, []);

  const handlePageChange = (pageKey) => {
    const selectedPage = pages.find((page) => page.pageKey === pageKey);

    setSelectedPageKey(pageKey);

    if (selectedPage) {
      setData({
        pageName: selectedPage.pageName || "",
        title: selectedPage.title || "",
        items: selectedPage.items || [],
      });
    }
  };

  const handleTitleChange = (value) => {
    setData((previous) => ({
      ...previous,
      title: value,
    }));
  };

  const handleItemChange = (index, field, value) => {
    setData((previous) => {
      const updatedItems = [...previous.items];

      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value,
      };

      return {
        ...previous,
        items: updatedItems,
      };
    });
  };

  const handleAddFaq = () => {
    setData((previous) => ({
      ...previous,
      items: [...previous.items, { ...emptyFaq }],
    }));
  };

  const handleRemoveFaq = (index) => {
    setData((previous) => ({
      ...previous,
      items: previous.items.filter((_, itemIndex) => itemIndex !== index),
    }));
  };

  const handleSave = async () => {
    if (!selectedPageKey) {
      return;
    }

    try {
      setSaving(true);

      const response = await fetch(
        `${API_BASE_URL}/api/faqs/${selectedPageKey}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            pageName: data.pageName,
            title: data.title,
            items: data.items,
          }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to save FAQs");
      }

      setData({
        pageName: result.data.pageName || "",
        title: result.data.title || "",
        items: result.data.items || [],
      });

      setPages((previous) =>
        previous.map((page) =>
          page.pageKey === selectedPageKey ? result.data : page
        )
      );

      alert("FAQs updated successfully");
    } catch (error) {
      console.error("FAQ save error:", error);
      alert(error.message || "Failed to save FAQs");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="cms-page">
        <div className="cms-page-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="cms-page">
      <div className="cms-page-header">
        <div>
          <h1>FAQs</h1>
          <p>
            Select a page and add, edit or delete the FAQ questions and answers
            shown on that page.
          </p>
        </div>

        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving || !selectedPageKey}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>

      <div className="cms-section-card">
        <div className="cms-section-card-header">
          <h2>Select Page</h2>
          <p>Choose which page FAQs you want to manage.</p>
        </div>

        <div className="cms-form-grid">
        <div className="cms-form-group">
          <label>Page</label>
          <select
            value={selectedPageKey}
            onChange={(e) => handlePageChange(e.target.value)}
          >
            {pages.map((page) => (
              <option key={page.pageKey} value={page.pageKey}>
                {page.pageName}
              </option>
            ))}
          </select>
        </div>

        <div className="cms-form-group">
          <label>Section Title</label>
          <input
            type="text"
            value={data.title || ""}
            onChange={(e) => handleTitleChange(e.target.value)}
          />
        </div>
        </div>
      </div>

      <div className="cms-section-card">
        <div className="cms-section-card-header">
          <h2>Questions & Answers</h2>
          <p>
            These FAQs appear on the selected page. Add, update or remove items
            as needed.
          </p>
        </div>

        <div className="cms-experience-cards">
          {data.items.map((item, index) => (
            <div className="cms-experience-card" key={index}>
              <div className="cms-experience-card-number">
                FAQ {index + 1}
              </div>

              <div className="cms-form-group">
                <label>Question</label>
                <input
                  type="text"
                  value={item.question || ""}
                  onChange={(e) =>
                    handleItemChange(index, "question", e.target.value)
                  }
                />
              </div>

              <div className="cms-form-group">
                <label>Answer</label>
                <textarea
                  rows="4"
                  value={item.answer || ""}
                  onChange={(e) =>
                    handleItemChange(index, "answer", e.target.value)
                  }
                />
              </div>

              <button
                type="button"
                className="cms-upload-btn"
                onClick={() => handleRemoveFaq(index)}
              >
                Delete FAQ
              </button>
            </div>
          ))}
        </div>

        <div className="cms-bottom-actions">
          <button
            type="button"
            className="cms-upload-btn"
            onClick={handleAddFaq}
          >
            Add FAQ
          </button>
        </div>
      </div>

      <div className="cms-bottom-actions">
        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving || !selectedPageKey}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default Faqs;
